export default "/images/f9529c55094db8651f10a7ecdda25d38.avif";